package com.ashes.dev.ai.weather.weathershow

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val SearchIcon: ImageVector
    get() {
        if (_SearchIcon != null) return _SearchIcon!!
        _SearchIcon = ImageVector.Builder(
            name = "SearchIcon",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                stroke = SolidColor(Color.White),
                strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(11f, 19f)
                arcToRelative(8f, 8f, 0f, isMoreThanHalf = true, isPositiveArc = false, 0f, -16f)
                arcToRelative(8f, 8f, 0f, isMoreThanHalf = false, isPositiveArc = false, 0f, 16f)
                close()
                moveTo(21f, 21f)
                lineTo(16.65f, 16.65f)
            }
        }.build()
        return _SearchIcon!!
    }

private var _SearchIcon: ImageVector? = null

val LocationIcon: ImageVector
    get() {
        if (_LocationIcon != null) return _LocationIcon!!
        _LocationIcon = ImageVector.Builder(
            name = "LocationIcon",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                stroke = SolidColor(Color.White),
                strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(21f, 10f)
                arcToRelative(9f, 9f, 0f, isMoreThanHalf = false, isPositiveArc = true, -9f, 9f)
                arcToRelative(9f, 9f, 0f, isMoreThanHalf = false, isPositiveArc = true, -9f, -9f)
                arcToRelative(9f, 9f, 0f, isMoreThanHalf = false, isPositiveArc = true, 18f, 0f)
                close()
                moveTo(12f, 13f)
                arcToRelative(3f, 3f, 0f, isMoreThanHalf = true, isPositiveArc = false, 0f, -6f)
                arcToRelative(3f, 3f, 0f, isMoreThanHalf = false, isPositiveArc = false, 0f, 6f)
                close()
            }
        }.build()
        return _LocationIcon!!
    }

private var _LocationIcon: ImageVector? = null

val SunriseIcon: ImageVector
    get() {
        if (_SunriseIcon != null) return _SunriseIcon!!
        _SunriseIcon = ImageVector.Builder(
            name = "SunriseIcon",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                stroke = SolidColor(Color.White),
                strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(12f, 2f)
                verticalLineToRelative(3f)
                moveTo(4.22f, 4.22f)
                lineToRelative(2.12f, 2.12f)
                moveTo(2f, 12f)
                horizontalLineToRelative(3f)
                moveTo(4.22f, 19.78f)
                lineToRelative(2.12f, -2.12f)
                moveTo(12f, 22f)
                verticalLineToRelative(-3f)
                moveTo(19.78f, 19.78f)
                lineToRelative(-2.12f, -2.12f)
                moveTo(22f, 12f)
                horizontalLineToRelative(-3f)
                moveTo(19.78f, 4.22f)
                lineToRelative(-2.12f, 2.12f)
                moveTo(16f, 12f)
                arcToRelative(4f, 4f, 0f, isMoreThanHalf = true, isPositiveArc = true, -8f, 0f)
                arcToRelative(4f, 4f, 0f, isMoreThanHalf = true, isPositiveArc = true, 8f, 0f)
                close()
            }
        }.build()
        return _SunriseIcon!!
    }

private var _SunriseIcon: ImageVector? = null

val SunsetIcon: ImageVector
    get() {
        if (_SunsetIcon != null) return _SunsetIcon!!
        _SunsetIcon = ImageVector.Builder(
            name = "SunsetIcon",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                stroke = SolidColor(Color.White),
                strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(12f, 13f)
                arcToRelative(7f, 7f, 0f, isMoreThanHalf = false, isPositiveArc = false, -7f, 7f)
                horizontalLineToRelative(14f)
                arcToRelative(7f, 7f, 0f, isMoreThanHalf = false, isPositiveArc = false, -7f, -7f)
                close()
                moveTo(12f, 2f)
                verticalLineToRelative(3f)
                moveTo(4.22f, 4.22f)
                lineToRelative(2.12f, 2.12f)
                moveTo(22f, 12f)
                horizontalLineToRelative(-3f)
                moveTo(19.78f, 4.22f)
                lineToRelative(-2.12f, 2.12f)
            }
        }.build()
        return _SunsetIcon!!
    }

private var _SunsetIcon: ImageVector? = null

val AppLogo: ImageVector
    get() {
        if (_AppLogo != null) return _AppLogo!!
        _AppLogo = ImageVector.Builder(
            name = "AppLogo",
            defaultWidth = 120.dp,
            defaultHeight = 120.dp,
            viewportWidth = 120f,
            viewportHeight = 120f
        ).apply {
            // Background Circle (for non-adaptive usage)
            path(fill = SolidColor(Color(0xFF1A237E))) {
                moveTo(60f, 60f)
                moveToRelative(-55f, 0f)
                arcToRelative(55f, 55f, 0f, isMoreThanHalf = true, isPositiveArc = true, 110f, 0f)
                arcToRelative(55f, 55f, 0f, isMoreThanHalf = true, isPositiveArc = true, -110f, 0f)
            }
            // Sun
            path(fill = SolidColor(Color(0xFFFFD600))) {
                moveTo(75f, 45f)
                moveToRelative(-18f, 0f)
                arcToRelative(18f, 18f, 0f, isMoreThanHalf = true, isPositiveArc = true, 36f, 0f)
                arcToRelative(18f, 18f, 0f, isMoreThanHalf = true, isPositiveArc = true, -36f, 0f)
            }
            // Cloud Shadow
            path(fill = SolidColor(Color(0x33000000))) {
                moveTo(35f, 85f)
                arcToRelative(16f, 16f, 0f, isMoreThanHalf = false, isPositiveArc = true, 16f, -16f)
                arcToRelative(16f, 16f, 0f, isMoreThanHalf = false, isPositiveArc = true, 16f, 6f)
                arcToRelative(13f, 13f, 0f, isMoreThanHalf = false, isPositiveArc = true, 20f, 11f)
                arcToRelative(13f, 13f, 0f, isMoreThanHalf = false, isPositiveArc = true, -13f, 13f)
                lineTo(35f, 99f)
                arcToRelative(13f, 13f, 0f, isMoreThanHalf = false, isPositiveArc = true, 0f, -26f)
            }
            // Cloud Main
            path(fill = SolidColor(Color.White)) {
                moveTo(30f, 80f)
                arcToRelative(16f, 16f, 0f, isMoreThanHalf = false, isPositiveArc = true, 16f, -16f)
                arcToRelative(16f, 16f, 0f, isMoreThanHalf = false, isPositiveArc = true, 16f, 6f)
                arcToRelative(13f, 13f, 0f, isMoreThanHalf = false, isPositiveArc = true, 20f, 11f)
                arcToRelative(13f, 13f, 0f, isMoreThanHalf = false, isPositiveArc = true, -13f, 13f)
                lineTo(30f, 94f)
                arcToRelative(13f, 13f, 0f, isMoreThanHalf = false, isPositiveArc = true, 0f, -26f)
            }
        }.build()
        return _AppLogo!!
    }

private var _AppLogo: ImageVector? = null
